let user = [
    {
        path: '/user/account',
        name: 'list',
        component: () => import('@/views/user/account/list.vue'),
        meta: {keepAlive: true, parentPath: 'user'},
    },
    {
        path: '/user/account/edit',
        name: 'edit',
        component: () => import('@/views/user/account/edit.vue'),
        meta: {keepAlive: true, parentPath: 'user'},
    }
   
    
    
]
export default user


// WEBPACK FOOTER //
// ./src/router/user.js